var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8435 6.43284H15.1991V6.39964H7.99955V9.59946H12.5205C11.8609 11.4622 10.0886 12.7993 7.99955 12.7993C5.3489 12.7993 3.19982 10.6502 3.19982 7.99955C3.19982 5.3489 5.3489 3.19982 7.99955 3.19982C9.22308 3.19982 10.3362 3.66139 11.1838 4.41535L13.4464 2.15268C12.0177 0.821154 10.1066 0 7.99955 0C3.5818 0 0 3.5818 0 7.99955C0 12.4173 3.5818 15.9991 7.99955 15.9991C12.4173 15.9991 15.9991 12.4173 15.9991 7.99955C15.9991 7.46318 15.9439 6.93961 15.8435 6.43284Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 4.27616L3.55013 6.20365C4.26129 4.44295 5.98359 3.19982 7.99908 3.19982C9.22261 3.19982 10.3357 3.66139 11.1833 4.41535L13.446 2.15268C12.0173 0.821154 10.1062 0 7.99908 0C4.92645 0 2.2618 1.7347 0.921875 4.27616Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00051 15.9991C10.0668 15.9991 11.9443 15.2084 13.3638 13.9225L10.8879 11.8274C10.0578 12.4587 9.04343 12.8001 8.00051 12.7993C5.91982 12.7993 4.15312 11.4726 3.48756 9.62109L0.878906 11.631C2.20283 14.2216 4.89148 15.9991 8.00051 15.9991Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.844 6.43359H15.1996V6.40039H8V9.60021H12.5209C12.2054 10.4867 11.6371 11.2614 10.8862 11.8285L10.8874 11.8277L13.3633 13.9228C13.1881 14.082 15.9995 12.0001 15.9995 8.0003C15.9995 7.46393 15.9444 6.94036 15.844 6.43359Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/Google Login.3612c5127977406f3301d8e6d72f5c7f.svg";
export { ForwardRef as ReactComponent };